/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-10-23T09:57:30.921
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveHrProjectParams,
	getHrProjectParamsCreateInit,
	getHrProjectParamsEditInit,
	getHrProjectParamsView,
	deleteHrProjectParams
} from '@api/rentmanage/HrProjectParams';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getHrProjectParamsCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getHrProjectParamsCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHrProjectParamsEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHrProjectParamsEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveHrProjectParams({}, HrProjectParams) {
			return new Promise((resolve, reject) => {
				saveHrProjectParams(HrProjectParams)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getHrProjectParamsView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHrProjectParamsView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteHrProjectParams({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHrProjectParams({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
